<template>
  <div class="dashboard">
    <nav
      class="navbar fixed-top bg-body-tertiary"
      style="background-color: #784ba0 !important"
    >
      <div class="container-fluid">
        <a
          class="navbar-brand cherry-bomb-one-regular"
          style="color: #fff; font-size: 20px"
          href="#"
          >Kinkyer Admin</a
        >
      </div>
    </nav>
    <div class="container-fluid" style="padding-top: 60px">
      <div class="row">
        <div class="col-2" style="padding: 10px">
          <div class="list-group" style="padding: 10px">
            <a
              href="#"
              @click="pageStatus = 1"
              class="list-group-item list-group-item-action"
              style="padding: 10px !important"
              >ダッシュボード</a
            >
            <a
              href="#"
              @click="pageStatus = 2"
              class="list-group-item list-group-item-action"
              style="padding: 10px !important"
              >本人確認</a
            >
            <a
              href="#"
              @click="pageStatus = 3"
              class="list-group-item list-group-item-action"
              style="padding: 10px !important"
              >画像チェック</a
            >
            <a
              href="#"
              @click="pageStatus = 4"
              class="list-group-item list-group-item-action"
              style="padding: 10px !important"
              >スクリプト実行</a
            >
          </div>
        </div>
        <div class="col-10">
          <div v-if="pageStatus == 1">
            <page1 />
          </div>
          <div v-else-if="pageStatus == 2">
            <page2 />
          </div>
          <div v-else-if="pageStatus == 3">
            <page3 />
          </div>
          <div v-else-if="pageStatus == 4">
            <page4 />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, db } from "../../plugins/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import page1 from "./page1View.vue";
import page2 from "./page2View.vue";
import page3 from "./page3View.vue";
import page4 from "./page4View.vue";

export default {
  data() {
    return {
      pageStatus: 1,
    };
  },
  components: {
    page1,
    page2,
    page3,
    page4,
  },
  created() {
    onAuthStateChanged(auth, async (user) => {
      if (user == null) {
        console.log("未ログイン");
        this.$router.push("/");
      } else {
        // 権限チェック
        const docRef = doc(db, "authLink", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const docUserRef = doc(db, "users", docSnap.data().uid);
          const docUserSnap = await getDoc(docUserRef);
          console.log(docUserSnap.data().uid);
          console.log(docUserSnap.data());
          if (docUserSnap.data().isAdminGrant) {
            console.log("管理者");
          } else {
            console.log("あかん");
            this.$router.push("/");
          }
        } else {
          console.log("未ログイン");
          this.$router.push("/");
        }
      }
    });
  },
};
</script>

<style scoped>
.dashboard {
  min-height: 100%;
  background-color: #f2f2f7;
}
</style>
